import Content from "components/Content"
import Navbar from "components/Navbar"
import React from "react"
import { Container } from "./style"
import { useLocation } from "react-router-dom"
import ScrollButton from "components/ScrollButton"

export default () => {
  const { pathname } = useLocation()

  function checkPathName() {
    if (
      pathname === "/" ||
      pathname.includes("/auth") ||
      pathname === "/contact-us" ||
      pathname === "/about-us"
    )
      return false
    return true
  }

  return (
    <Container>
      <Navbar isAuthPage={pathname.includes("/auth") ? true : false} />
      <Content
        className={
          checkPathName()
            ? "px-4 md:px-6 2xl:px-10 py-10 mx-auto max-w-[1920px]"
            : "bg-[rgba(0,0,0,0.7)]"
        }
      />
      <ScrollButton />
    </Container>
  )
}
